import React, { useRef, useState, useEffect } from "react";
import "./style.css";

import styles from "styles.module.css";

import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { addMonths, addWeeks } from "date-fns";
import OverLayLoading from "ui/Loading";
import { useTranslation } from "react-i18next";
import { pickListGridColumnItem } from "./utils/GridColumns";
import Filter from "./Filter";
import { getPickListApi, PickListFilter } from "api/pickList";
import { useUserStore } from "store/user";
import { UserRole } from "interface/user";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
// import style from "./style.module.css";

const pageSize = 60;

const PickListPage = () => {
	const { t } = useTranslation();
	const { roles } = useUserStore();

	const overlayRef = useRef<HTMLDivElement>(null);

	var fromDate = addMonths(new Date(), -12);

	if (roles.includes(UserRole.Admin)) {
		fromDate = addWeeks(new Date(), -1);
	}

	const gridRef = useRef<HTMLDivElement>(null);
	const [filterOptions, setFilterOptions] = useState<PickListFilter>({
		take: pageSize,
		skip: 0,
		fromDate: fromDate,
		toDate: new Date(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const exportGridAsPDF = () => {
		if (pdfRef.current !== null) {
			pdfRef.current.save();
		}
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	return (
		<div className={styles.PageContainer}>
			<div ref={overlayRef} style={{ display: "none" }}>
				<OverLayLoading />
			</div>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>{t("PickList")}</legend>
			</div>

			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div style={{}} ref={gridRef}>
				<GridWithGroupPaging
					gridColumns={pickListGridColumnItem()}
					filter={filterOptions}
					exportGridAsPDFRef={pdfRef}
					exportGridAsExcelRef={excelRef}
					apiMethod={getPickListApi}
					// className={"pick-list-group-grid"}  // adding this class the grid will remove the tongle of grouping
					itemAboveHeight={50}
					pageable={false}
					group={[
						{
							field: "group1",
							// aggregates: [
							// 	{ field: "netLiveWeightKg", aggregate: "sum" },
							// ],
						},
						{
							field: "group2",
							aggregates: [{ field: "netLiveWeightKg", aggregate: "sum" }],
						},
					]}
				/>
			</div>
		</div>
	);
};

export default PickListPage;
